import FieldProto from "../../../fields3/proto/field-proto"
import {SortDirection} from "../../../data-structures/sort"
import {GroupByConfig} from "./@types"
import TaskFields from "../../../model2/task/task-fields"

// const debug = "GroupBy"
const debug = false

export default class GroupBy {
    field?          : FieldProto
    sortDirection   : SortDirection
    params          : any

    constructor(data: GroupByConfig, fields: TaskFields = gd.fields.task) {
        debug && console.log(debug, 'constructor', data, fields)

        this.field          = data.fieldId ? fields.get(data.fieldId) : undefined
        this.sortDirection  = data.sortDirection || SortDirection.ASC
        this.params         = data.params || {}
    }

    static convertFromOldFormatToJSON(groupType: string) {
        const groupBy = new GroupBy({})
        groupBy.field = gd.fields.task.getFieldByField1Id(groupType) || undefined
        return groupBy.toJSON()
    }

    toJSON() {
        return {
            fieldId         : this.field?.fieldId,
            sortDirection   : this.sortDirection,
            params          : this.params
        }
    }
}